class MembershipDropdown extends HTMLElement {
  constructor() {
    super()

    this.apiUrl = 'https://admin.f4d.space/api/shopify/membership'
    this.config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: `application/json`,
        Authorization:
          'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkYXRhIjoiY2xpZW50IiwiZXhwIjoxNzI2ODQ5MjI1NTM3LCJpYXQiOjE2NjM3NzcyMjV9.3j5DSp1wxF2hi6rgYckXfgvppXgA-9bQn2aUfZKYUDg',
      },
      mode: 'cors'
    }

    this.bouquetsDropdown = this.querySelector('#bouquets-dropdown')
    this.bouquetsDropdownOptions = this.querySelector('#bouquets-dropdown-options')
    this.ordersDropdown = this.querySelector('#orders-dropdown')
    this.ordersDropdownOptions = this.querySelector('#orders-dropdown-options')
    this.donationYes = this.querySelector('#yes-option')
    this.donationNo = this.querySelector('#no-option')
    this.membershipForm = this.querySelector('#membership-form')

    this.init()
  }

  init() {
    this.bouquetsDropdown.addEventListener('click', this.handleBouquetsDropdownToggle.bind(this))
    this.bouquetsDropdownOptions.addEventListener('click', this.handleBouquetsDropdownSelection.bind(this))
    this.ordersDropdown.addEventListener('click', this.handleOrdersDropdownToggle.bind(this))
    this.ordersDropdownOptions.addEventListener('click', this.handleOrdersDropdownSelection.bind(this))
    document.addEventListener('click', this.handleOutsideClick.bind(this))
    this.donationYes.addEventListener('click', this.handleYesNoClick.bind(this, 'Yes'))
    this.donationNo.addEventListener('click', this.handleYesNoClick.bind(this, 'No'))
    this.membershipForm.addEventListener('submit', this.handleFormSubmit.bind(this))
  }

  handleBouquetsDropdownToggle() {
    this.bouquetsDropdownOptions.classList.toggle('hidden')
  }

  handleOrdersDropdownToggle() {
    this.ordersDropdownOptions.classList.toggle('hidden')
  }

  handleBouquetsDropdownSelection(event) {
    if (event.target.matches('li')) {
      const value = event.target.getAttribute('data-value')
      this.querySelector('#bouquets-selected').textContent = value
      this.querySelector('#bouquets-count').value = value
      this.bouquetsDropdownOptions.classList.add('hidden')
    }
  }

  handleOrdersDropdownSelection(event) {
    if (event.target.matches('li')) {
      const value = event.target.getAttribute('data-value')
      this.querySelector('#orders-selected').textContent = value
      this.querySelector('#order-count').value = value
      this.ordersDropdownOptions.classList.add('hidden')
    }
  }

  handleOutsideClick(event) {
    if (!this.bouquetsDropdown.contains(event.target) && !this.bouquetsDropdownOptions.contains(event.target)) {
      this.bouquetsDropdownOptions.classList.add('hidden')
    }

    if (!this.ordersDropdown.contains(event.target) && !this.ordersDropdownOptions.contains(event.target)) {
      this.ordersDropdownOptions.classList.add('hidden')
    }
  }

  handleYesNoClick(value) {
    if (value === 'Yes') {
      this.donationYes.classList.add('bg-offblack', 'text-white')
      this.donationYes.classList.remove('bg-white')

      this.donationNo.classList.add('bg-white')
      this.donationNo.classList.remove('bg-offblack', 'text-white')
    } else {
      this.donationNo.classList.add('bg-offblack', 'text-white')
      this.donationNo.classList.remove('bg-white')

      this.donationYes.classList.add('bg-white')
      this.donationYes.classList.remove('bg-offblack', 'text-white')
    }

    this.querySelector('#donate').value = value
  }

  async handleFormSubmit(event) {
    event.preventDefault()
    const formData = new FormData(this.membershipForm)
    const {
      'membership[first_name]': firstName,
      'membership[last_name]': lastName,
      'membership[email]': email,
      'membership[phone]': phone,
      'membership[bouquets_sent]': bouquetsSent,
      'membership[local_charity]': localCharity,
      'membership[order_count]': orderCount,
      'membership[donate]': donate,
    } = Object.fromEntries(formData.entries())

    this.clearErrorMessages()

    if (!this.isValidEmail(email)) return

    if (orderCount === '1-2' || orderCount === '3-5') {
      this.displayErrorMessage('Must commit to at least 6 bouquets a year')
      return
    }

    const customerUpserted = await this.upsertCustomer({
      firstName,
      lastName,
      email,
      phone,
      bouquetsSent,
      localCharity,
      orderCount,
      donate
    })

    if (customerUpserted) {
      this.querySelector('#form-wrapper').classList.add('hidden')
      this.querySelector('#success-wrapper').classList.remove('hidden')
      document.getElementById('main-hero-img').classList.add('hidden')
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    } else {
      this.displayErrorMessage('Sorry, there was an issue on our end')
    }
  }

  clearErrorMessages() {
    const errorContainer = this.querySelector('.form-error-message')
    if (errorContainer.innerText.length) errorContainer.innerText = ''
    
  }

  displayErrorMessage(message) {
    const errorContainer = this.querySelector('.form-error-message')
    if (errorContainer) {
      errorContainer.textContent = message
      errorContainer.classList.toggle('hidden', !message) // Show or hide based on the message
    }
  }
  
  isValidEmail(email) {
    let trimmedEmail = email ? email.trim().toLowerCase() : ''
    let domain = null
    let suffix = null
    let isValid = false
  
    // Extract domain and suffix
    try {
      const domainMatch = trimmedEmail.match(/(\.[^.]*)$/)
      domain = domainMatch ? domainMatch[0].slice(1) : null
      suffix = trimmedEmail.match(/(\@[^]*)$/)[0].slice(1)
    } catch {
      this.displayErrorMessage('Invalid email address.')
      return false
    }
  
    // Validate domain and suffix
    if (!domain || !suffix) {
      this.displayErrorMessage('Invalid email address.')
      return false
    }
  
    // Common typos in email domains
    if (suffix?.includes('gamil') || suffix?.includes('gmial')) {
      this.displayErrorMessage('Did you mean gmail.com?')
      return false
  
      // Basic email validation with regex
    } else if (/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,12}$/.test(trimmedEmail)) {
      this.displayErrorMessage('') // Clear any previous error message
      isValid = true
    } else {
      this.displayErrorMessage('Invalid email address.')
      return false
    }
  
    return isValid
  }

  async upsertCustomer(membershipData) {
    this.config.body = JSON.stringify({ membershipData })

    const response = await fetch(this.apiUrl, this.config)
    const data = await response.json()
    
    return data?.success
  }
}

customElements.define('membership-form', MembershipDropdown)
